/* JAQUAN CHANGE: quick view for "Completes the setup" parts (snippets/bf-pairs-with).
   Tapping a part opens a panel on the same page (right side on desktop, bottom
   sheet on phones) with every photo, price, shipping time, a few specs and
   Add to cart. The panel content is sections/bf-quick-view.liquid, loaded on
   tap from /products/<handle>?section_id=bf-quick-view and kept for the visit.
   Adding uses the theme's cart drawer (<mini-cart>), same as the main
   Add to cart button. Cmd/Ctrl/middle-click still open the full page.
   Sends bf_quick_view and bf_quick_view_add to Shopify customer events.
   No animations. */
(function () {
  'use strict';
  if (window.BFQuickView) return;

  var cache = {};
  var dialog = null;
  var body = null;
  var lastRow = null;
  var lastFocus = null;
  var savedOverflow = '';

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
  }

  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'bf-qv';
    dialog.setAttribute('aria-label', 'Part preview');
    dialog.innerHTML =
      '<div class="bf-qv__panel">' +
      '<button type="button" class="bf-qv__close" data-bf-qv-close aria-label="Close">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
      '</button>' +
      '<div class="bf-qv__body" data-bf-qv-body></div>' +
      '</div>';
    document.body.appendChild(dialog);
    body = dialog.querySelector('[data-bf-qv-body]');

    dialog.addEventListener('click', function (event) {
      // Click on the dark backdrop (the dialog itself, outside the panel) closes.
      if (event.target === dialog || event.target.closest('[data-bf-qv-close]')) close();
    });
    dialog.addEventListener('close', afterClose);
  }

  function open(row) {
    if (!dialog) build();
    lastRow = row;
    lastFocus = document.activeElement;
    body.innerHTML = '<p class="bf-qv__loading">Loading…</p>';
    savedOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    var url = new URL(row.getAttribute('href'), location.origin);
    url.search = '';
    var key = url.pathname;
    var handle = (key.match(/\/products\/([^/?#]+)/) || [])[1] || '';
    track('bf_quick_view', { product: handle, from_product: currentHandle() });

    if (cache[key]) {
      render(cache[key]);
      return;
    }
    url.searchParams.set('section_id', 'bf-quick-view');
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (html) {
        cache[key] = html;
        if (lastRow === row && dialog.open) render(html);
      })
      .catch(function () {
        // Can't load the preview: just go to the part's page.
        location.href = row.getAttribute('href');
      });
  }

  function close() {
    if (dialog && dialog.open) {
      if (typeof dialog.close === 'function') dialog.close();
      else {
        dialog.removeAttribute('open');
        afterClose();
      }
    }
  }

  function afterClose() {
    document.documentElement.style.overflow = savedOverflow;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function render(html) {
    body.innerHTML = html;
    var product = body.querySelector('[data-bf-qv-product]');
    if (!product) return;

    // Same short name the row shows ("Krawler Rear Bumper" instead of the full title).
    var rowName = lastRow && lastRow.querySelector('.bf-inline__name');
    var title = product.querySelector('.bf-qv__title');
    if (rowName && title && rowName.textContent.trim()) title.textContent = rowName.textContent.trim();

    // Fits / Won't fit: copy the label already worked out on the tapped row.
    var chip = lastRow && lastRow.querySelector('[data-bf-inline-fit]');
    var fit = product.querySelector('[data-bf-qv-fit]');
    if (chip && fit && !chip.hidden && chip.textContent.trim()) {
      fit.innerHTML = chip.innerHTML;
      fit.className = 'bf-qv__fit' + (chip.classList.contains('bf-inline__fit--no') ? ' bf-qv__fit--no' : '');
      fit.hidden = false;
    }

    initSet(product);
    initGallery(product);
    initVariant(product);
    product.querySelector('[data-bf-qv-add]').addEventListener('click', function () {
      add(product, this);
    });
    var closeBtn = dialog.querySelector('[data-bf-qv-close]');
    if (closeBtn) closeBtn.focus();
  }

  function initGallery(product) {
    var track = product.querySelector('[data-bf-qv-track]');
    var thumbs = product.querySelectorAll('[data-bf-qv-thumb]');
    var count = product.querySelector('[data-bf-qv-count]');
    if (!track || !thumbs.length) return;
    var total = thumbs.length;

    function mark(index) {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
      });
      if (count) count.textContent = index + 1 + ' / ' + total;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.getAttribute('data-bf-qv-thumb'), 10) || 0;
        track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' });
        mark(index);
      });
    });

    var queued = false;
    track.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          var width = track.clientWidth || 1;
          mark(Math.min(total - 1, Math.max(0, Math.round(track.scrollLeft / width))));
        });
      },
      { passive: true }
    );

    track.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      var width = track.clientWidth || 1;
      var index = Math.round(track.scrollLeft / width) + (event.key === 'ArrowRight' ? 1 : -1);
      index = Math.min(total - 1, Math.max(0, index));
      track.scrollTo({ left: index * width, behavior: 'auto' });
      mark(index);
    });
  }

  // Sold in sets (wheels): the product page's Add to cart block sets the product
  // type and quantity (data-set-type / data-set-qty on the page). Parts of that
  // type add that many.
  function setQtyFor(product) {
    var page = document.querySelector('[data-bf-pdp][data-set-type]');
    if (!page) return 1;
    var type = page.getAttribute('data-set-type');
    var n = parseInt(page.getAttribute('data-set-qty'), 10) || 1;
    return n > 1 && type && product.getAttribute('data-type') === type ? n : 1;
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function addLabel(product) {
    var n = setQtyFor(product);
    return n > 1 ? 'Add set of ' + n + ' to cart' : 'Add to cart';
  }

  function showSet(product, cents) {
    var line = product.querySelector('[data-bf-qv-set]');
    var n = setQtyFor(product);
    if (!line || n < 2) return;
    line.textContent = 'Set of ' + n + ': ' + money(cents * n);
    line.hidden = false;
  }

  function initSet(product) {
    if (setQtyFor(product) < 2) return;
    showSet(product, parseInt(product.getAttribute('data-cents'), 10) || 0);
    var btn = product.querySelector('[data-bf-qv-add]');
    if (btn && !btn.disabled) btn.textContent = addLabel(product);
  }

  function initVariant(product) {
    var select = product.querySelector('[data-bf-qv-variant]');
    if (!select) return;
    var idInput = product.querySelector('[data-bf-qv-id]');
    var price = product.querySelector('[data-bf-qv-price]');
    var btn = product.querySelector('[data-bf-qv-add]');
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      idInput.value = option.value;
      if (price) price.textContent = option.getAttribute('data-price');
      var available = option.getAttribute('data-available') === 'true';
      btn.disabled = !available;
      btn.textContent = available ? addLabel(product) : 'Sold out';
      showSet(product, parseInt(option.getAttribute('data-cents'), 10) || 0);
    });
  }

  function showError(product, message) {
    var box = product.querySelector('[data-bf-qv-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
  }

  function add(product, btn) {
    if (btn.disabled) return;
    var variantId = product.querySelector('[data-bf-qv-id]').value;
    var handle = product.getAttribute('data-handle');
    var minicart = document.querySelector('mini-cart');
    var form = new FormData();
    form.append('id', variantId);
    form.append('quantity', String(setQtyFor(product)));
    if (minicart && typeof minicart.getSectionsToRender === 'function' && typeof getUniqueSectionNames === 'function') {
      form.append('sections', getUniqueSectionNames(minicart.getSectionsToRender()));
      form.append('sections_url', location.pathname);
    }

    showError(product, '');
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: form
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          showError(product, response.description || response.message || 'That didn’t go through. Please try again.');
          btn.disabled = false;
          btn.textContent = addLabel(product);
          return;
        }
        track('bf_quick_view_add', {
          product: handle,
          variant: String(variantId),
          from_product: currentHandle()
        });
        close();
        if (minicart && typeof minicart.renderContents === 'function') {
          minicart.renderContents(response);
          if (typeof minicart.open === 'function') minicart.open();
        } else {
          location.href = '/cart';
          return;
        }
        // Tell the theme a part was added (same event its own Add to cart sends).
        try {
          if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            window.publish(PUB_SUB_EVENTS.cartItemAdd, { source: 'bf-quick-view', items: [response] });
          }
        } catch (e) {}
      })
      .catch(function () {
        showError(product, 'That didn’t go through. Please try again.');
        btn.disabled = false;
        btn.textContent = addLabel(product);
      });
  }

  document.addEventListener('click', function (event) {
    var row = event.target.closest && event.target.closest('.bf-pairs a.bf-inline');
    if (!row) return;
    // Let new-tab clicks behave normally.
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    open(row);
  });

  window.BFQuickView = { open: open, close: close };
})();
